<script>
  import Bleed from "$lib/components/Bleed.svelte";
  import TabButton from "$lib/components/TabButton.svelte";
  import Icon from "$lib/components//Icon.svelte";
  import { textToId } from "$lib/utilities/dom-helpers";

  export let data;
  export let linkClasses = "";

  let clazz = "";
  export { clazz as class };

  let shouldShowControls = false;
  let containerWidth = 0;
  let navbarWidth = 0;
  let navbar;
  let screenWidth;
  let activeJumpLinkIndex = 0;
  let activeJumpLink = data.fields.items?.[activeJumpLinkIndex];
  let useMobileStyle = false;

  const scrollIncrement = 300;
  const mdBreakpoint = 834;

  function addItemWidth(node) {
    navbarWidth += node.offsetWidth;
  }

  function determineJumpLinkIndex(px) {
    const maxJumpLinkIndex = data.fields.items?.length - 1;
    if (px < 0) {
      activeJumpLinkIndex = activeJumpLinkIndex === 0 ? maxJumpLinkIndex : --activeJumpLinkIndex;
    } else if (px > 0) {
      activeJumpLinkIndex = activeJumpLinkIndex === maxJumpLinkIndex ? 0 : ++activeJumpLinkIndex;
    }

    activeJumpLink = data.fields.items?.[activeJumpLinkIndex];
  }

  function doHorizontalScroll(px = 0) {
    if (navbar) {
      if (screenWidth >= mdBreakpoint) {
        navbar.scrollLeft += px;
      } else {
        determineJumpLinkIndex(px);
      }
    }
  }

  $: {
    useMobileStyle = screenWidth < mdBreakpoint;
    shouldShowControls =
      navbarWidth > containerWidth || (useMobileStyle && data.fields.items?.length > 1);
  }
</script>

<svelte:window bind:innerWidth={screenWidth} />

{#if data.fields.items}
  <Bleed fullWidth={!useMobileStyle} class="embedded-content">
    <nav class="max-w-screen-lg m-auto w-312 h-64 md:w-full md:h-72">
      <h2 id="jump-links-label" class="sr-only">Page Section Jump Links</h2>
      <div
        class="flex flex-row justify-center border border-neutral-100 rounded-10 bg-white h-full {clazz}"
      >
        {#if shouldShowControls}
          <button
            aria-label={useMobileStyle ? "View Previous Item" : "Scroll Left"}
            class="flex flex-row justify-center items-center h-full bg-surface-100 outline-0 border border-b-2 border-transparent rounded-10 md:rounded-0 hover:border-neutral-300 active:bg-neutral-100 active:border-b-2 active:border-b-neutral-900 focus:border-b-2 focus:border-neutral-900 md:p-24 w-56 md:w-72"
            on:click={() => doHorizontalScroll(-scrollIncrement)}
          >
            <Icon type="chevron-left" />
          </button>
        {/if}

        <ul
          class="list-none flex flex-col md:flex-row items-center md:scroll-smooth md:overflow-hidden md:snap-x md:snap-mandatory"
          aria-labelledby="jump-links-label"
          class:justify-center={!shouldShowControls}
          bind:clientWidth={containerWidth}
          bind:this={navbar}
        >
          {#each data.fields.items as child}
            {@const headline = useMobileStyle
              ? activeJumpLink.fields.headline
              : child.fields.headline}
            <li
              class="flex flex-row justify-center md:inline-block snap-always snap-center"
              use:addItemWidth
            >
              {#if !useMobileStyle || (useMobileStyle && activeJumpLink.fields.headline.includes(child.fields.headline))}
                <TabButton
                  url="#{textToId(headline)}"
                  text={headline}
                  textClasses="text-size-14 md:text-size-base whitespace-normal md:whitespace-nowrap w-[200px] md:w-full"
                  class="{linkClasses} items-center text-center h-64 !px-0 !py-auto md:!px-32 md:!py-24"
                />
              {/if}
            </li>
          {/each}
        </ul>

        {#if shouldShowControls}
          <button
            aria-label={useMobileStyle ? "View Next Item" : "Scroll Right"}
            class="flex flex-row justify-center items-center h-full bg-surface-100 outline-0 border border-b-2 rounded-10 md:rounded-0 border-transparent hover:border-neutral-300 active:bg-neutral-100 active:border-b-2 active:border-b-neutral-900 focus:border-b-2 focus:border-neutral-900 focus:outline-none md:p-24 w-56 md:w-72"
            on:click={() => doHorizontalScroll(scrollIncrement)}
          >
            <Icon type="chevron-right" />
          </button>
        {/if}
      </div>
    </nav>
  </Bleed>
{/if}
